import { Link } from "react-router-dom";
import { gossipLiveUpdates } from "@/mocks/gossipLiveUpdates";
import { getCategoryName } from "@/utils/category";

const stats = [
  { label: "今日更新", value: "128", unit: "条" },
  { label: "实时在线", value: "3.2", unit: "万" },
  { label: "覆盖话题", value: "46", unit: "个" },
];

export default function HeroSection() {
  const highlights = gossipLiveUpdates.slice(0, 4);

  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=moody%20dark%20theatre%20audience%20seats%20lit%20by%20warm%20amber%20stage%20light%20with%20haze%2C%20stylized%20cinematic%20editorial%20atmosphere%2C%20no%20people%2C%20deep%20crimson%20and%20gold%20tones&width=1600&height=900&seq=gua-hero-01&orientation=landscape"
          alt="瓜料动态实时资讯氛围图"
          title="瓜料动态 - 今日更新实时吃瓜"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/90 to-foreground-950/55" />
      </div>

      <div className="relative mx-auto grid w-full max-w-shell gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3.5 py-1.5 text-xs font-label text-background-100 ring-1 ring-background-50/20">
            <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-accent-400" />
            全天候滚动更新 · 不打烊
          </span>
          <h1 className="mt-5 font-heading text-4xl font-bold leading-[1.15] text-background-50 md:text-5xl lg:text-[3.4rem]">
            瓜料动态
            <span className="mt-2 block text-xl font-medium text-background-200 md:text-2xl">
              今日更新不停档，实时吃瓜不迷路
            </span>
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            把散落在各处的圈内消息、话题进展和热搜变化，整理成一条随时可刷的时间线。不用再蹲各路小道消息，最新进展集中看。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#live"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              查看今日更新
            </a>
            <a
              href="#hot"
              className="whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-center font-label text-sm text-background-50 transition-colors hover:bg-background-50/10"
            >
              进入热搜榜
            </a>
          </div>

          <dl className="mt-9 grid max-w-md grid-cols-3 gap-4">
            {stats.map((item) => (
              <div key={item.label} className="border-l border-background-50/20 pl-4">
                <dd className="font-heading text-2xl font-bold text-background-50">
                  {item.value}
                  <span className="ml-1 text-xs font-normal text-background-300">{item.unit}</span>
                </dd>
                <dt className="mt-1 text-xs text-background-300">{item.label}</dt>
              </div>
            ))}
          </dl>
        </div>

        <div className="rounded-lg border border-background-50/15 bg-background-50/[0.07] p-5 backdrop-blur-sm md:p-6">
          <div className="flex items-center justify-between">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
              <span className="live-dot inline-block h-2 w-2 rounded-full bg-primary-400" />
              今日更新速览
            </h2>
            <span className="text-xs text-background-300">按时间倒序</span>
          </div>
          <ul className="mt-4 divide-y divide-background-50/10">
            {highlights.map((item) => (
              <li key={`${item.time}-${item.title}`} className="flex gap-3 py-3.5">
                <span className="mt-0.5 shrink-0 font-label text-xs font-bold text-accent-300">{item.time}</span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium leading-snug text-background-50">{item.title}</span>
                  <span className="mt-1 block text-xs leading-relaxed text-background-300">{item.detail}</span>
                  <span className="mt-1.5 inline-block rounded-full bg-background-50/10 px-2 py-0.5 text-[11px] text-background-200">
                    {getCategoryName(item.categorySlug)}
                  </span>
                </span>
              </li>
            ))}
          </ul>
          <Link
            to="/#live"
            className="mt-4 inline-flex items-center gap-1.5 text-sm text-accent-300 transition-colors hover:text-accent-200"
          >
            查看全部 {gossipLiveUpdates.length} 条更新
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}